import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const useProtectedAction = () => {
  const { token } = useAuth();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [actionType, setActionType] = useState('action');

  const executeAction = useCallback((action, type = 'action') => {
    if (!token) {
      setActionType(type);
      setAuthModalOpen(true);
      return false;
    }
    action();
    return true;
  }, [token]);

  return {
    executeAction,
    authModalOpen,
    setAuthModalOpen,
    actionType,
  };
};

export default useProtectedAction;
